import React from 'react';

import fetch from '../../fetch';

import moment from 'moment';

import utils from '../../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号', width: 75},
    {key:'orgName', label: '所属部门'},
    {key:'employeeCode', label: '督导工号'},
    {key:'employeeName', label: '督导名称'},
    {key:'count', label: '选课次数'},
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('course/plan/selection/task/selectionOverviewList', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}


/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
};

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'course'+ url;
};

const getSelection =() => {
    return DataGrid.selections;
}

/**
 * 数据导出
 * @method exportList
 * @param {object} [keywords]
 * @return {promise}
 */
 const exportList = (keywords) => {
    return fetch.download('course/plan/selection/task/selectionOverview/export', keywords, "督导选课详情导出.xls")
}


export default {
    insertURL: '#/course/insert',
    querySearch,
    columns,
    onSelect,
    setRefresh,
    redirect,
    getSelection,
    exportList
}